module.exports = __webpack_public_path__ + "static/img/software1.5d3b39d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software1.jpg
// module id = tiQF
// module chunks = 2